export default __webpack_public_path__ + "static/media/hdKitchen.898ebabd.svg";